/**
 * Shared checkbox list for PoR page layout (workspace default or per-record).
 */
import {
  POR_PAGE_GROUP_ORDER,
  POR_PAGE_REGISTRY,
  type PorPageDefinition,
} from '../../lib/porPageSettingsService';

export function PorPageLayoutForm({
  isVisible,
  onToggle,
  onlyOneVisible,
  disabled,
}: {
  isVisible: (key: string) => boolean;
  onToggle: (key: string) => void;
  onlyOneVisible: boolean;
  disabled?: boolean;
}) {
  return (
    <div className="space-y-6">
      {POR_PAGE_GROUP_ORDER.map(({ group, label }) => {
        const pages = POR_PAGE_REGISTRY.filter((p) => p.group === group);
        return (
          <div key={group}>
            <h3 className="text-sm font-semibold text-[var(--text-sec)] dark:text-[var(--text-sec)] mb-3">
              {label}
            </h3>
            <div className="card space-y-2 p-3">
              {pages.map((page) => (
                <PageToggleRow
                  key={page.key}
                  page={page}
                  isVisible={isVisible(page.key)}
                  disabled={disabled || (isVisible(page.key) && onlyOneVisible)}
                  onToggle={() => onToggle(page.key)}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function PageToggleRow({
  page,
  isVisible,
  onToggle,
  disabled,
}: {
  page: PorPageDefinition;
  isVisible: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <label
      className={`flex items-start gap-3 p-4  border cursor-pointer transition-colors ${
        isVisible
          ? 'bg-[var(--bg-raised)] border-[var(--rule)] dark:bg-[var(--surface)] dark:border-[var(--rule)]'
          : 'bg-[var(--surface)] border-[var(--rule)] dark:bg-[var(--bg)] dark:border-[var(--rule)]'
      } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
    >
      <input
        type="checkbox"
        checked={isVisible}
        onChange={onToggle}
        disabled={disabled}
        className="mt-1 h-4 w-4 rounded border-[var(--rule)] text-primary-600 focus:ring-primary-500"
      />
      <div className="flex-1 min-w-0">
        <p
          className={`text-sm font-semibold ${isVisible ? 'text-[var(--text-pri)] dark:text-[var(--text-pri)]' : 'text-[var(--text-ter)]'}`}
        >
          {page.name}
        </p>
        <p
          className={`text-sm mt-0.5 ${isVisible ? 'text-[var(--text-ter)] dark:text-[var(--text-sec)]' : 'text-[var(--text-ter)]'}`}
        >
          {page.description}
        </p>
      </div>
    </label>
  );
}
